import { createFileRoute } from "@tanstack/react-router";

import EvidenceList from "@/pages/evidence/EvidenceList";

export const Route = createFileRoute("/evidence/")({
  component: EvidenceList,
});
